import { Button } from "../ui/button";
import { Input } from "../ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

const colorOptions = [
  "#6366f1", "#10b981", "#06b6d4", "#ef4444", "#f59e0b",
  "#3b82f6", "#8b5cf6", "#ec4899", "#64748b", "#14b8a6",
  "#f97316", "#84cc16", "#a855f7", "#0ea5e9",
];

export function CategoryFormDialog({
  open,
  onOpenChange,
  formData,
  setFormData,
  onSubmit,
  isEditing,
  loading,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800 max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-white font-['Outfit']">
            {isEditing ? "Edit Category" : "New Category"}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <label className="text-sm text-slate-400 mb-1 block">
              Category Name
            </label>
            <Input
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              placeholder="e.g., Frozen Foods"
              className="bg-slate-950 border-slate-800"
              data-testid="category-name-input"
              autoFocus
            />
          </div>

          <div>
            <label className="text-sm text-slate-400 mb-1 block">Color</label>
            <div className="flex flex-wrap gap-2">
              {colorOptions.map((color) => (
                <button
                  key={color}
                  type="button"
                  onClick={() => setFormData({ ...formData, color })}
                  className={`w-8 h-8 rounded-full transition-transform ${
                    formData.color === color
                      ? "ring-2 ring-white ring-offset-2 ring-offset-slate-900 scale-110"
                      : ""
                  }`}
                  style={{ backgroundColor: color }}
                  data-testid={`category-color-${color.replace("#", "")}`}
                />
              ))}
            </div>
          </div>

          <div className="flex gap-3 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="flex-1 border-slate-700"
              data-testid="category-cancel-button"
            >
              Cancel
            </Button>
            <Button
              onClick={onSubmit}
              disabled={loading}
              className="flex-1 bg-amber-600 hover:bg-amber-500"
              data-testid="category-submit-button"
            >
              {loading ? "Saving..." : isEditing ? "Update" : "Create"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
